// src/components/RecenterButton.js
import React from "react";
import { IconButton } from "@mui/material";
import IconRecenter from "../assets/icons/icon-recenter.svg";

export default function RecenterButton({ onClick, sx, disabled = false, ...rest }) {
  return (
    <IconButton
      aria-label="Recenter map"
      onClick={onClick}
      disabled={disabled}
      sx={[
        (theme) => ({
          backgroundColor: theme.colors.blue,
          border: `2px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.28)" : "rgba(255,255,255,0.72)"}`,
          "&:hover": { backgroundColor: theme.colors.blue },
          width: 48,
          height: 48,
        }),
        ...(Array.isArray(sx) ? sx : [sx]).filter(Boolean),
      ]}
      {...rest}
    >
      <img src={IconRecenter} alt="Recenter map" style={{ width: 24, height: 24 }} />
    </IconButton>
  );
}
